import { useCallback, useMemo } from 'react';

import { useUser } from 'hooks/auth';

import { getRobotPermission } from 'lib/constants/get-robot-permission';
import RoleTypes, { Permission } from 'lib/constants/role-types';

import { useRobotIdParam } from '../myRobot';

// todo refactor for RBAC: only the hole app is protected by "basic" and this can also be used for "admin" check
export function useAccess() {
  const { isAdmin, roles, permissions } = useUser();
  const { robotId } = useRobotIdParam(false);

  const checkPermission = useCallback(
    (permission: Permission) => isAdmin || getRobotPermission(robotId, permissions, permission),
    [isAdmin, robotId, permissions],
  );

  const hasViewPermission = useMemo(
    () => isAdmin || getRobotPermission(robotId, permissions, Permission.VIEW),
    [isAdmin, robotId, permissions],
  );

  const hasControlPermission = useMemo(
    () => isAdmin || getRobotPermission(robotId, permissions, Permission.CONTROL),
    [isAdmin, robotId, permissions],
  );

  const hasMissionExecutionPermission = useMemo(
    () => isAdmin || getRobotPermission(robotId, permissions, Permission.MISSION_EXECUTION),
    [isAdmin, robotId, permissions],
  );

  const hasArmControlPermission = useMemo(
    () => isAdmin || getRobotPermission(robotId, permissions, Permission.ARM_CONTROL),
    [isAdmin, robotId, permissions],
  );

  const checkRole = useCallback(
    (role: RoleTypes) => roles.includes(RoleTypes.ADMIN) || roles.includes(role),
    [roles],
  );

  return useMemo(
    () => ({
      checkRole,
      checkPermission,
      hasViewPermission,
      hasControlPermission,
      hasMissionExecutionPermission,
      hasArmControlPermission,
    }),
    [checkRole, checkPermission, hasViewPermission, hasControlPermission, hasMissionExecutionPermission, hasArmControlPermission],
  );
}

export default useAccess;
